module.exports = __webpack_public_path__ + "static/media/knight-frank.1651e45d.png";